import PropTypes from "prop-types"
import React from "react"

const ToggleSwitch = ({
  startPosition,
  tellParent,
  additionalCssClasses = "",
  labelLeft,
  labelRight,
}) => {
  // No need to track position in state since we can just use the prop directly
  // and let the parent component handle state updates

  const flipSwitch = (forcedPosition) => {
    const newPosition =
      forcedPosition || (startPosition === "left" ? "right" : "left")
    tellParent(newPosition)
  }

  const flipLeft = () => flipSwitch("left")
  const flipRight = () => flipSwitch("right")

  const renderLeftLabel = () => {
    if (labelLeft) {
      return (
        <label tabIndex="0" onKeyPress={flipLeft} onClick={flipLeft}>
          {labelLeft}
        </label>
      )
    }
    return null
  }

  const renderRightLabel = () => {
    if (labelRight) {
      return (
        <label tabIndex="0" onKeyPress={flipRight} onClick={flipRight}>
          {labelRight}
        </label>
      )
    }
    return null
  }

  return (
    <div className="toggle-switch-component">
      {renderLeftLabel()}
      <div
        className={
          "toggle-switch " +
          additionalCssClasses +
          " toggle-switch-" +
          startPosition
        }
        onClick={() => flipSwitch()}
      />
      {renderRightLabel()}
    </div>
  )
}

ToggleSwitch.propTypes = {
  startPosition: PropTypes.oneOf(["left", "right"]).isRequired,
  tellParent: PropTypes.func.isRequired,
  additionalCssClasses: PropTypes.string,
  labelLeft: PropTypes.node,
  labelRight: PropTypes.node,
}

export default ToggleSwitch
